import { render, staticRenderFns } from "./OrderDetailHistory.vue?vue&type=template&id=4cf88667&scoped=true"
import script from "./OrderDetailHistory.vue?vue&type=script&lang=js"
export * from "./OrderDetailHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailHistory.vue?vue&type=style&index=0&id=4cf88667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf88667",
  null
  
)

export default component.exports